import React, { Component } from "react";

import "../css/LocationSection.css";

class LocationSection extends Component {
  // PLACE ID GOOGLE: ChIJHSxeOLZnV0sRqbT8Yr4Pbeg

  initializeMap(props) {
    // var map = new window.google.maps.Map(document.getElementById("map"), {
    //   zoom: 15,
    // });
    // marker = new window.google.maps.Marker({
    //   map: map,
    //   position: props.place.geometry && this.place.geometry.location,
    // });
    // map.setCenter(marker.getPosition());
  }

  componentDidMount() {
    if (this.props.place) this.initializeMap(this.props);
  }

  componentDidUpdate(prevProps) {
    if (this.props.place !== prevProps.place) {
      this.initializeMap(this.props);
    }
  }

  renderInformation() {
    const { opening_hours, formatted_address, formatted_phone_number } =
        this.props.place,
      { open_now } = opening_hours;

    return (
      <React.Fragment>
        {open_now ? (
          <p style={{ color: "#2b890f", fontSize: ".8em" }}>Now Open</p>
        ) : (
          <p style={{ color: "#890e0e", fontSize: ".8em" }}>Closed</p>
        )}
        <hr className='thin-black' />
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {opening_hours.weekday_text.map((day, idx) => (
              <tr key={idx}>
                <td>{day}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <hr className='thin-black' />
        <div className='contact-info'>
          <p>
            <strong>{formatted_address}</strong>
          </p>
          <p>{formatted_phone_number}</p>
        </div>
      </React.Fragment>
    );
  }

  render() {
    return (
      <div>
        <div className='container location-section'>
          <h3>Location Information</h3>
          <div className='row'>
            {/* <div className='col-lg-6 map-column' id='map'></div> */}
            <div className='col-lg-12 hours-column'>
              {this.props.place ? this.renderInformation() : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LocationSection;



// WEBPACK FOOTER //
// ./src/components/LocationSection.jsx